import { Box, Button, Stack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { OverlayRouter } from "../../components/OverlayRouter";
import { IRootStore } from "../../stores";
import { STEPS } from "../../stores/utils";
import VerificationIdentity from "../../tutor-revamp/VerificationIdentity";
import { useClientSteps } from "../utils";
export type VerificationPageProps = {
  store: IRootStore;
  afterUpload: () => any;
  onBack?: () => any;
  loading?: boolean;
  buttonText?: string;
  onSubmit: (payload: any) => any;
  onSkip?: () => any;
  children?: React.ReactNode;
};

function VerificationPage({
  store,
  afterUpload,
  onBack,
  buttonText = "Back to application",
  loading,
  onSkip,
  onSubmit,
}: VerificationPageProps) {
  const { onSubmitSection, getFormWrapperProps } = useClientSteps(
    STEPS.VERIFICATION,
    store,
  );

  const verifyIdentityProps = {
    ...getFormWrapperProps(STEPS.VERIFICATION),
    buttonText: "Save",
    buttonProps: {
      width: "30%",
      float: "right",
      display: "none",
    },
    loading,
    // onSubmit: onSubmitSection,
  };
  return (
    <Box as="section" className="forms-section">
      <VerificationIdentity
        {...verifyIdentityProps}
        includeProfilePhoto={false}
        afterUpload={afterUpload}
        displayNotice={false}
        onSkip={onSkip}
        onSubmit={() => onSubmit(store.identity.formValues())}
      />
    </Box>
  );
}

export const StandaloneVerificationPage: React.FC<VerificationPageProps> = (
  props,
) => {
  return (
    <OverlayRouter>
      <VerificationPage {...props} />
    </OverlayRouter>
  );
};

export default observer(VerificationPage);
